import { BasicRequest } from "./basicRequest";

export class UndeleteMoovDefinitionRequest extends BasicRequest{
    public moovDefinitionId! : number;
}